import React from "react";

const IntroBox = () => {
  return (
    <div className="intro">
      <div className="box">
        <div className="column">
          <span>WELCOME</span>
          <span>WILLKOMMEN</span>
        </div>
        <div className="column">
          <span>გამარჯობა</span>
          <span>欢迎</span>
        </div>
      </div>
    </div>
  );
};

export default IntroBox;
